<template>
  <SfCarousel
    v-if="!isDesktop"
    class="categories-slider"
    :settings="categoryListSliderSettings"
  >
    <template #prev>
      <div />
    </template>
    <SfCarouselItem
      v-for="(category, index) in categoriesList"
      :key="`categories-slider-${index}`"
      class="categories-slider__category"
    >
      <CustomCta
        :theme="currentCategoryId === category.uid ? 'dark' : 'light'"
        :link="localePath(`/${category.url_key}`)"
      >
        <span>
          {{ category.name }}
        </span>
      </CustomCta>
    </SfCarouselItem>
    <template #next>
      <div />
    </template>
  </SfCarousel>
  <div v-else class="categories-slider-desktop">
    <div class="categories-slider-desktop__wrapper">
      <div
        v-for="(category, index) in categoriesList"
        :key="`categories-slider-desktop-${index}`"
        class="categories-slider-desktop__wrapper__category"
      >
        <CustomCta
          :theme="currentCategoryId === category.uid ? 'dark' : 'light'"
          :link="localePath(`/${category.url_key}`)"
        >
          <span>
            {{ category.name }}
          </span>
        </CustomCta>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { SfCarousel } from '@storefront-ui/vue';
import { CustomCta } from '~/components/General';
import { useWindow } from '~/composables';

export default defineComponent({
  name: 'CategoryListSlider',
  components: {
    SfCarousel,
    CustomCta,
  },
  props: {
    categoriesList: {
      type: Array,
      required: true,
    },
    currentCategoryId: {
      type: String,
      required: true,
    },
  },
  setup() {
    const { isDesktop } = useWindow();

    const categoryListSliderSettings = {
      type: 'carousel',
      perView: 10,
      startAt: 0,
      gap: 10,
      peek: {
        before: 25,
        after: 25,
      },
      breakpoints: {
        360: {
          perView: 1,
          peek: 75,
        },
        767: {
          perView: 2,
          peek: 100,
        },
        1023: {
          perView: 6,
          peek: 50,
        },
      },
    };
    return {
      isDesktop,
      categoryListSliderSettings,
    };
  },
});
</script>

<style lang="scss">
.categories-slider {
  margin-bottom: 3.75rem;
  --carousel-width: 100%;
  &__category {
    min-width: fit-content;
    width: fit-content;
  }
  &-desktop {
    padding-bottom: 0.75rem;
    margin-bottom: 3rem;
    width: 100%;
    overflow-y: auto;
    @include desktop-boxed;
    &__wrapper {
      width: max-content;
      &__category {
        display: inline-block;
        margin: 0 0.3125rem;
      }
    }
  }
}
</style>
